// extracted by mini-css-extract-plugin
module.exports = {"ElectorList":"ElectorList_ElectorList__15JwT"};